export const SITE_TYPE = "SHOPBY";

export const SHOPBY_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/common/loginA.html" },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/common/join.html" },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/common/mypageMain.html" },
  FIND_ID: {
    target: `${SITE_TYPE}:FIND_ID`,
    url: "/common/email_find.html",
  },
  FIND_PASSWORD: {
    target: `${SITE_TYPE}:FIND_PASSWORD`,
    url: "/common/password_find.html",
  },
  CART: { target: `${SITE_TYPE}:CART`, url: "/common/cart.html" },
  POLICY: { target: `${SITE_TYPE}:POLICY`, url: "/common/agreement.html" },
  PRIVACY: { target: `${SITE_TYPE}:PRIVACY`, url: "/common/privacy.html" },
  PRODUCT_DETAIL: {
    target: `${SITE_TYPE}:PRODUCT_DETAIL`,
    url: "/common/product.html",
  },
  // 상품상세와 다르게 상품목록 주소는  사용자가 정의해서 특정하기 어려움
};
